<script>
  import { Modal, ModalBody } from "sveltestrap";

  export let product;
  let open = false;

  const toggle = () => (open = !open);

  export const show = () => {
    toggle();
  };
</script>

<div class="container">
  <link rel="preload" as="image" href="./img/QRScan.png" />
  <Modal isOpen={open} {toggle} class="modal-dialog-centered modal-md">
    <ModalBody class="modalBody">
      <div class="bodyContainer">
        <button class="closeBtn" on:click={toggle} />
        <img src={product["ARCodeImg"]} alt="QR Code" class="QRCode" />
        <img src="./img/QRScan.png" alt="AR-QR Code" class="QRScan" />
        <p class="content">
          So geht’s: Kamera-App öffnen. Kamera auf den QR Code richten.
          Angezeigten Link tippen. Kamera mit 1,5 m Abstand auf Boden richten.
          Objekt wird platziert. Voraussetzung: funktioniert mit den meisten
          Smartphones und Pads, ab: Android 7.0 / iOS 12 / iPadOS.
        </p>
      </div>
    </ModalBody>
  </Modal>
</div>

<style>
  :global(.modal-content) {
    border-radius: 20px !important;
  }
  .container :global(.modalBody) {
    -webkit-border-radius: 20px !important;
    -moz-border-radius: 20px !important;
    border-radius: 20px !important;
    -webkit-border: 20px !important;
    -moz-border: 20px !important;
    border: 20px !important;
  }
  .bodyContainer {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
  }

  .QRCode,
  .QRScan {
    height: auto;
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
  }
  .QRCode {
    width: 70%;
  }
  .QRScan {
    width: calc(70% + 30px);
    margin-left: 30px;
  }
  .bodyContainer p {
    font-family: "latoRegular", sans-serif;

    margin: 15px 10px 30px;
    color: rgb(130, 130, 130);
    line-height: 20px;

    font-size: 15px;
  }
  .closeBtn {
    background: url(../img/btn/closebtn.png);
    display: block;
    width: 45px;
    height: 45px;

    background-size: 100% 100%;
    border: 0px;
    opacity: 0.5;
    margin-left: auto;
  }

  /* End of popup css */
  @media only screen and (max-height: 500px) {
    :global(.modal-content) {
      /* height: 265px !important; */
      width: 195.7px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
    }
    .closeBtn {
      width: 25px;
      height: 25px;
    }
    .QRCode {
      margin-top: -10px;
    }
    .content {
      margin: 5px 0 0 !important;
    }
    .bodyContainer p {
      font-size: 0.9rem;
      line-height: 0.9rem;
      transform: scale(0.7);
      margin: -15px 0px -15px !important;
    }
    .QRScan {
      width: calc(70% + 20px);
      margin-left: 16px;
    }
  }
  @media only screen and (max-width: 500px) and (max-height: 900px) {
    :global(.modal-content) {
      width: 295.4px !important;
      height: 400px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
    }
    .closeBtn {
      width: 30px;
      height: 30px;
    }
    .QRCode {
      margin-top: -25px;
    }
    .bodyContainer p {
      font-size: 0.9rem;
      line-height: 0.9rem;
      transform: scale(0.9);
      margin: -5px 0px -15px !important;
    }
    .QRScan {
      width: calc(70% + 20px);
      margin-left: 16px;
    }
  }
  @media only screen and (min-width: 500px) and (max-height: 700px) and (min-height: 450px) {
    :global(.modal-content) {
      /* height: 450px !important; */
      height: 470px !important;
      width: 332.3px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
    }
    .closeBtn {
      width: 25px;
      height: 25px;
    }
    .QRCode {
      margin-top: -10px;
    }
    .bodyContainer p {
      font-size: 0.9rem;
      line-height: 0.9rem;
      margin: 5px 0 0 !important;
      transform: none;
    }
    .QRScan {
      width: calc(70% + 20px);
      margin-left: 16px;
    }
  }
</style>
